import React, { useState, useEffect, useRef } from "react";
import ReactDOM from "react-dom";
import logoMascota from "../../../../assets/logo-mascota.png";

export default function MascotaOculta({ alCerrar }) {
  const [esHoraMagica, setEsHoraMagica] = useState(false);
  const [juegoAbierto, setJuegoAbierto] = useState(alCerrar ? true : false);

  // Estados visuales del juego
  const [jugando, setJugando] = useState(false);
  const [gameOver, setGameOver] = useState(false);
  const [victoria, setVictoria] = useState(false); 
  const [puntuacion, setPuntuacion] = useState(0);
  const [miRecordMaximo, setMiRecordMaximo] = useState(0);
  
  // Posiciones visuales
  const [birdTop, setBirdTop] = useState(150);
  const [rotacion, setRotacion] = useState(0);
  const [obstaculoLeft, setObstaculoLeft] = useState(400); 
  const [obstaculoHeight, setObstaculoHeight] = useState(120);

  // Rankings de BD
  const [rankingBD, setRankingBD] = useState([]);

  // Tamaños de Hitbox 
  const BIRD_X = 60;       
  const BIRD_SIZE = 40; 
  const PIPE_WIDTH = 60;   
  const GAP = 150;      

  const usuarioLocal = JSON.parse(localStorage.getItem("usuario") || "{}");
  const nombreUsuario = usuarioLocal.nombres || usuarioLocal.correo || "Tú";
  const centroTrabajoUsuario = usuarioLocal.centroTrabajo || usuarioLocal.cargo || "Actual";

  const velocidadY = useRef(0);
  const posicionY = useRef(150);
  const posObstaculoX = useRef(400);
  const puntajeRef = useRef(0);

  // 1. HORA MÁGICA
  useEffect(() => {
    const revisarHora = () => {
      setEsHoraMagica(true); 
    };
    revisarHora();
    const intervalo = setInterval(revisarHora, 60000);
    return () => clearInterval(intervalo);
  }, []);

  // 2. CARGAR Y GUARDAR EN BASE DE DATOS
  const cargarRankingGlobal = async () => {
    try {
      const token = localStorage.getItem("token");
      const API_URL = process.env.REACT_APP_API_URL;
      
      const response = await fetch(`${API_URL}/api/juego/ranking`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          ...(token && { Authorization: `Bearer ${token}` })
        }
      });
      
      if (response.ok) {
        const data = await response.json();
        // FILTRO ESTRICTO: Solo aceptamos los puntajes que pertenezcan a Flappy Surtidor
        const rankingFlappy = Array.isArray(data) ? data.filter(d => d.juego === 'flappy_surtidor') : [];
        setRankingBD(rankingFlappy);
        
        const miPuntajeDB = rankingFlappy.find(user => user.nombre === nombreUsuario);
        if (miPuntajeDB) {
          setMiRecordMaximo(miPuntajeDB.puntos);
        }
      }
    } catch (error) {
      setRankingBD([{ nombre: nombreUsuario, centro: centroTrabajoUsuario, puntos: 0, juego: 'flappy_surtidor' }]);
    }
  };

  const guardarPuntajeEnBD = async (puntosNuevos) => {
    if (puntosNuevos <= miRecordMaximo) return; 

    try {
      const token = localStorage.getItem("token");
      const API_URL = process.env.REACT_APP_API_URL;

      const response = await fetch(`${API_URL}/api/juego/guardar`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          ...(token && { Authorization: `Bearer ${token}` })
        },
        body: JSON.stringify({
          nombre: nombreUsuario,
          centro: centroTrabajoUsuario,
          puntos: puntosNuevos,
          juego: "flappy_surtidor"
        })
      });

      if (response.ok) {
        setMiRecordMaximo(puntosNuevos); 
        cargarRankingGlobal(); 
      }
    } catch (error) {
      setMiRecordMaximo(puntosNuevos);
    }
  };

  useEffect(() => {
    if (juegoAbierto) cargarRankingGlobal();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [juegoAbierto]);

  const perderJuego = () => {
    setGameOver(true);
    setJugando(false);
    if (puntajeRef.current > 0) {
      guardarPuntajeEnBD(puntajeRef.current);
    }
  };

  // 3. MOTOR DE FÍSICA
  useEffect(() => {
    let loop;
    if (jugando && !gameOver && !victoria) {
      loop = setInterval(() => {
        velocidadY.current += 0.4; 
        posicionY.current += velocidadY.current;
        const nuevoAngulo = Math.min(Math.max(velocidadY.current * 4, -20), 70);
        
        const velocidadJuego = Math.min(3 + Math.floor(puntajeRef.current / 3), 8);
        posObstaculoX.current -= velocidadJuego;

        const tocaPiso = posicionY.current > 440; 
        const tocaTecho = posicionY.current < -20;
        const enRangoTubo = posObstaculoX.current < BIRD_X + BIRD_SIZE - 10 && posObstaculoX.current + PIPE_WIDTH > BIRD_X + 10;
        const chocaTuboArriba = posicionY.current + 5 < obstaculoHeight;
        const chocaTuboAbajo = posicionY.current + BIRD_SIZE - 5 > obstaculoHeight + GAP;

        if (tocaPiso || tocaTecho || (enRangoTubo && (chocaTuboArriba || chocaTuboAbajo))) {
          perderJuego();
        }

        if (posObstaculoX.current < -PIPE_WIDTH) {
          posObstaculoX.current = 400; 
          setObstaculoHeight(Math.floor(Math.random() * 160) + 60); 
          puntajeRef.current += 1;
          setPuntuacion(puntajeRef.current);

          if (puntajeRef.current >= 999) {
            setVictoria(true);
            setJugando(false);
            guardarPuntajeEnBD(999);
          }
        }

        setBirdTop(posicionY.current);
        setRotacion(nuevoAngulo);
        setObstaculoLeft(posObstaculoX.current);
      }, 16); 
    }
    return () => clearInterval(loop);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [jugando, gameOver, victoria, obstaculoHeight]);

  const saltar = (e) => {
    e.preventDefault();
    if (victoria) return;
    
    if (!jugando && !gameOver) {
      setJugando(true);
      setGameOver(false);
      setPuntuacion(0);
      puntajeRef.current = 0;
      posicionY.current = 150;
      velocidadY.current = -7; 
      posObstaculoX.current = 400; 
    } else if (jugando) {
      velocidadY.current = -7; 
    }
  };

  const reiniciarJuego = (e) => {
    e.stopPropagation();
    setGameOver(false);
    setVictoria(false);
    setJugando(true);
    setPuntuacion(0);
    puntajeRef.current = 0;
    posicionY.current = 150;
    velocidadY.current = -7;
    posObstaculoX.current = 400;
  };

  const rankingDinámico = [
    ...rankingBD,
    { nombre: nombreUsuario, centro: centroTrabajoUsuario, puntos: Math.max(puntuacion, miRecordMaximo), esUsuario: true }
  ].reduce((acc, current) => {
    const x = acc.find(item => item.nombre === current.nombre);
    if (!x) return acc.concat([current]);
    x.puntos = Math.max(x.puntos, current.puntos);
    return acc;
  }, []).sort((a, b) => b.puntos - a.puntos).slice(0, 10);

  if (!esHoraMagica) return null;

  return (
    <>
      {!juegoAbierto && !alCerrar && (
        <button onClick={() => setJuegoAbierto(true)} className="fixed bottom-0 right-4 sm:right-6 z-[99999] group cursor-pointer transition-transform duration-300 hover:-translate-y-2">
          <div className="bg-white/70 backdrop-blur-[25px] rounded-t-[28px] px-4 pt-3 pb-2 shadow-[0_-10px_30px_rgba(0,0,0,0.12)] border border-white/90 border-b-0 flex items-center gap-2.5 relative">
            <span className="absolute -top-1 -right-1 w-3 h-3 bg-red-500 rounded-full animate-ping"></span>
            <span className="absolute -top-1 -right-1 w-3 h-3 bg-red-500 rounded-full"></span>
            <img src={logoMascota} alt="Mascota" className="w-8 h-8 object-contain animate-bounce pointer-events-none drop-shadow-sm" />
            <span className="text-[11px] font-black uppercase tracking-widest text-slate-800 hidden sm:group-hover:inline-block">¡Jugar!</span>
          </div>
        </button>
      )}

      {juegoAbierto &&
        ReactDOM.createPortal(
          <div className="fixed inset-0 z-[999999] bg-slate-950/50 backdrop-blur-md flex items-center justify-center p-3 sm:p-6 transition-all animate-fade-in">
            <div className={`bg-white/60 backdrop-blur-[50px] rounded-[36px] shadow-[0_30px_90px_rgba(0,0,0,0.2)] p-4 sm:p-8 border border-white/90 w-full max-h-[95vh] overflow-y-auto flex flex-col lg:flex-row gap-6 transition-all duration-500 mx-auto
              ${jugando ? 'max-w-md' : 'max-w-4xl'}
            `}>
              
              <button 
                onClick={() => {
                  setJuegoAbierto(false);
                  if (alCerrar) alCerrar();
                }} 
                className="absolute top-4 right-4 sm:top-6 sm:right-6 bg-white/70 hover:bg-white w-9 h-9 rounded-full font-bold text-slate-700 transition z-50 text-sm shadow-md backdrop-blur-md border border-white flex items-center justify-center cursor-pointer hover:rotate-90 duration-300"
              >
                ✕
              </button>

              <div className="flex-1 flex flex-col items-center w-full relative bg-transparent">
                {!jugando && (
                  <h3 className="text-xl font-black text-slate-800 uppercase tracking-tight mb-4 drop-shadow-sm text-center">
                    Flappy Surtidor
                  </h3>
                )}

                <div 
                  onPointerDown={saltar}
                  className="w-full max-w-[340px] h-[480px] bg-gradient-to-b from-sky-300 via-sky-200 to-sky-100 rounded-[28px] relative overflow-hidden cursor-pointer shadow-[inset_0_0_20px_rgba(0,0,0,0.1)] select-none mx-auto ring-4 ring-white/80 ring-inset"
                >
                  <div className="absolute top-6 w-full text-center z-20 pointer-events-none transition-transform duration-200">
                    <span className="text-white text-6xl font-black drop-shadow-[0_4px_12px_rgba(0,0,0,0.3)] inline-block" style={{ textShadow: "0px 4px 10px rgba(0,0,0,0.25)" }}>{puntuacion}</span>
                  </div>

                  <div className="absolute z-10 flex items-center justify-center pointer-events-none"
                    style={{ top: `${birdTop}px`, left: `${BIRD_X}px`, width: `${BIRD_SIZE}px`, height: `${BIRD_SIZE}px`, transform: `rotate(${rotacion}deg)`, transition: "transform 0.05s ease-out" }}
                  >
                    {victoria && <span className="absolute -top-8 text-3xl animate-bounce">👑</span>}
                    <img src={logoMascota} alt="Mascota" className="w-full h-full object-contain drop-shadow-xl" />
                  </div>

                  {jugando && (
                    <>
                      <div className="absolute bg-gradient-to-r from-emerald-500 via-emerald-400 to-emerald-600 border-[3px] border-emerald-800 rounded-b-xl shadow-lg pointer-events-none" style={{ left: `${obstaculoLeft}px`, top: 0, height: `${obstaculoHeight}px`, width: `${PIPE_WIDTH}px` }} />
                      <div className="absolute bg-gradient-to-r from-emerald-500 via-emerald-400 to-emerald-600 border-[3px] border-emerald-800 rounded-t-xl shadow-lg bottom-0 pointer-events-none" style={{ left: `${obstaculoLeft}px`, height: `calc(480px - ${obstaculoHeight + GAP}px)`, width: `${PIPE_WIDTH}px` }} />
                    </>
                  )}

                  {!jugando && !gameOver && !victoria && (
                    <div className="absolute inset-0 bg-slate-900/20 backdrop-blur-[6px] flex flex-col items-center justify-center p-4 z-30 pointer-events-none overflow-hidden rounded-[28px] animate-fade-in">
                      <div className="bg-white/90 backdrop-blur-2xl p-6 rounded-[24px] text-center shadow-[0_20px_50px_rgba(0,0,0,0.15)] border border-white w-full max-w-[240px] transform transition-all scale-100">
                        <div className="w-12 h-12 bg-blue-50 rounded-2xl mx-auto flex items-center justify-center mb-3 shadow-inner">
                          <img src={logoMascota} alt="Icon" className="w-8 h-8 object-contain animate-pulse" />
                        </div>
                        <p className="text-slate-800 font-black text-base mb-1">¡Toca para Saltar!</p>
                        <p className="text-slate-500 text-[11px] font-medium mb-4">Esquiva los obstáculos</p>
                        <button className="bg-gradient-to-r from-blue-600 to-blue-500 hover:from-blue-500 hover:to-blue-600 text-white font-black py-3 w-full rounded-xl shadow-[0_10px_20px_rgba(37,99,235,0.3)] text-sm active:scale-95 transition-all border border-blue-400/50 pointer-events-auto cursor-pointer">
                          COMENZAR
                        </button>
                      </div>
                    </div>
                  )}

                  {gameOver && (
                    <div className="absolute inset-0 bg-slate-950/40 backdrop-blur-[6px] flex flex-col items-center justify-center p-4 z-30 pointer-events-none overflow-hidden rounded-[28px] animate-fade-in">
                      <div className="bg-white/90 backdrop-blur-2xl p-6 rounded-[24px] text-center shadow-[0_20px_50px_rgba(0,0,0,0.2)] border border-white w-full max-w-[240px]">
                        <span className="text-3xl block mb-1">💥</span>
                        <p className="text-red-500 font-black text-2xl mb-3 drop-shadow-sm tracking-wide">¡AUCH!</p>
                        <div className="bg-slate-100/80 p-3 rounded-2xl border border-slate-200/60 mb-5 shadow-inner">
                          <p className="text-slate-500 text-[10px] uppercase tracking-widest font-extrabold mb-0.5">Puntuación Final</p>
                          <p className="font-black text-slate-900 text-4xl">{puntuacion}</p>
                        </div>
                        <button onPointerDown={reiniciarJuego} className="bg-gradient-to-r from-blue-600 to-blue-500 hover:from-blue-500 hover:to-blue-600 text-white font-black py-3 w-full rounded-xl shadow-[0_10px_20px_rgba(37,99,235,0.3)] active:scale-95 transition-all border border-blue-400/50 pointer-events-auto cursor-pointer text-sm">
                          REINTENTAR
                        </button>
                      </div>
                    </div>
                  )}
                </div>
              </div>

              {!jugando && (
                <div className="w-full lg:w-[320px] flex flex-col mt-4 lg:mt-0 lg:pt-10 animate-fade-in mx-auto bg-transparent">
                  <div className="bg-white/70 backdrop-blur-xl rounded-[30px] p-5 shadow-[0_15px_35px_rgba(0,0,0,0.1)] border border-white/90 flex-1 flex flex-col">
                    <h4 className="text-xs font-black text-slate-800 uppercase tracking-widest mb-4 flex items-center gap-2 justify-center pb-3 border-b border-slate-200/60">
                      🏆 TOP EMPRESA
                    </h4>
                    <div className="flex flex-col gap-2.5 flex-1 overflow-y-auto max-h-[300px] lg:max-h-[380px] pr-1">
                      {rankingDinámico.length === 0 ? (
                        <p className="text-center text-xs text-slate-500 mt-10 font-medium px-4">Sé el primero en jugar y deja tu récord registrado.</p>
                      ) : (
                        rankingDinámico.map((item, index) => {
                          const esTop1 = index === 0;
                          return (
                            <div key={index} className={`rounded-2xl p-3 flex items-center justify-between border backdrop-blur-md transition-all ${item.esUsuario ? 'bg-blue-50/90 border-blue-200 shadow-sm ring-1 ring-blue-400/30' : 'bg-white/60 border-white/80 hover:bg-white/80'}`}>
                              
                              <div className="flex items-center gap-3 flex-1 overflow-hidden">
                                <span className={`text-xs font-black w-7 h-7 shrink-0 rounded-full flex items-center justify-center shadow-sm ${esTop1 ? 'bg-gradient-to-br from-yellow-300 to-yellow-500 text-yellow-950 text-sm shadow-yellow-500/20' : 'bg-slate-200/80 text-slate-700'}`}>
                                  {esTop1 ? '👑' : index + 1}
                                </span>
                                
                                <div className="flex-1 min-w-0 pr-2">
                                  <p className="text-[13px] font-bold text-slate-800 leading-tight break-words whitespace-normal">{item.nombre}</p>
                                  <p className="text-[10px] text-slate-500 font-medium leading-tight mt-0.5 break-words whitespace-normal">{item.centro}</p>
                                </div>
                              </div>

                              <span className={`text-xs shrink-0 font-black px-3 py-1 rounded-xl shadow-sm ${esTop1 ? 'text-yellow-900 bg-yellow-100 border border-yellow-300' : 'text-blue-900 bg-blue-100/80 border border-blue-200/50'}`}>
                                {item.puntos} pts
                              </span>
                            </div>
                          );
                        })
                      )}
                    </div>
                  </div>
                </div>
              )}

            </div>
          </div>,
          document.body
        )}
    </>
  );
}